import React, { useEffect, useState } from 'react';
import { Button, Form, InputGroup } from 'react-bootstrap';
import PropTypes from 'prop-types';

export const SurfaceFilter = ({
  setFiltersAndSort,
  filtersAndSort,
  noCovered,
  noApply
}) => {
  const [surface, setSurface] = useState(filtersAndSort.surface);

  useEffect(() => {
    setSurface(filtersAndSort.surface);
  }, [filtersAndSort]);

  const handleSubmit = () =>
    setFiltersAndSort(prev => ({
      ...prev,
      surface: {
        min: surface.min,
        max: surface.max,
        type: surface.type
      }
    }));

  return (
    <div className="d-flex gap-sm-3 gap-lg-0 flex-column flex-sm-row flex-lg-column mt-0 justify-content-between align-items-sm-end align-items-lg-start">
      <Form.Group>
        <Form.Label>Superficie</Form.Label>

        {!noCovered && (
          <div className="d-flex gap-3">
            <div className="d-flex align-items-center gap-1">
              <Form.Check
                type="radio"
                name="surface"
                id="ars"
                onChange={() => {
                  if (noApply) {
                    setFiltersAndSort(prev => ({
                      ...prev,
                      surface: {
                        ...prev.surface,
                        type: 'totalSurface'
                      }
                    }));
                  } else {
                    setSurface(state => ({ ...state, type: 'totalSurface' }));
                  }
                }}
                checked={surface.type === 'totalSurface'}
                className="m-0"
              />
              <label style={{ marginTop: 2, marginBottom: 0 }}>Total</label>
            </div>

            <div className="d-flex align-items-center gap-1">
              <Form.Check
                type="radio"
                name="surface"
                id="usd"
                onChange={() => {
                  if (noApply) {
                    setFiltersAndSort(prev => ({
                      ...prev,
                      surface: {
                        ...prev.surface,
                        type: 'coveredSurface'
                      }
                    }));
                  } else {
                    setSurface(state => ({ ...state, type: 'coveredSurface' }));
                  }
                }}
                checked={surface.type === 'coveredSurface'}
                className="m-0"
              />

              <label style={{ marginTop: 2, marginBottom: 0 }}>Cubierta</label>
            </div>
          </div>
        )}
      </Form.Group>

      <div className="d-flex flex-column flex-sm-row gap-2">
        <Form.Group className="w-100 w-sm-auto">
          <Form.Label className="fs--2">Desde</Form.Label>
          <InputGroup>
            <Form.Control
              type="number"
              size="sm"
              value={surface.min}
              onChange={e => {
                if (noApply) {
                  setFiltersAndSort(prev => ({
                    ...prev,
                    surface: {
                      ...prev.surface,
                      min: e.target.value
                    }
                  }));
                } else {
                  setSurface(state => ({
                    ...state,
                    min: e.target.value
                  }));
                }
              }}
            />

            <InputGroup.Text className="px-2 fs--1">m²</InputGroup.Text>
          </InputGroup>
        </Form.Group>

        <Form.Group className="w-100 w-sm-auto">
          <Form.Label className="fs--2">Hasta</Form.Label>
          <InputGroup>
            <Form.Control
              type="number"
              size="sm"
              value={surface.max}
              onChange={e => {
                if (noApply) {
                  setFiltersAndSort(prev => ({
                    ...prev,
                    surface: {
                      ...prev.surface,
                      max: e.target.value
                    }
                  }));
                } else {
                  setSurface(state => ({
                    ...state,
                    max: e.target.value
                  }));
                }
              }}
            />

            <InputGroup.Text className="px-2 fs--1">m²</InputGroup.Text>
          </InputGroup>
        </Form.Group>
      </div>

      {!noApply && (
        <div className="mt-3 d-flex flex-column flex-sm-row gap-2 w-100 w-sm-50 w-lg-100">
          <Button
            className="w-100 w-sm-auto"
            style={{ flexGrow: 1 }}
            size="sm"
            variant="primary"
            onClick={handleSubmit}
          >
            Aplicar
          </Button>
          <Button
            className="w-100 w-sm-auto"
            style={{ flexGrow: 1 }}
            size="sm"
            variant="secondary"
            onClick={() => {
              setFiltersAndSort(prev => ({
                ...prev,
                surface: {
                  min: '',
                  max: '',
                  type: 'totalSurface'
                }
              }));
            }}
          >
            Limpiar
          </Button>
        </div>
      )}
    </div>
  );
};

SurfaceFilter.propTypes = {
  setFiltersAndSort: PropTypes.func.isRequired,
  filtersAndSort: PropTypes.object.isRequired,
  noCovered: PropTypes.bool,
  noApply: PropTypes.bool
};
